import { lazy, LazyExoticComponent, FC } from 'react';
import {
  HomeSkeleton,
  ProductsSkeleton,
  ProductDetailSkeleton,
  HistorySkeleton,
  ArticleSkeleton,
  ContactSkeleton,
  ConsultSkeleton,
} from '../components/PageSkeletons';

const Home = lazy(() => import('../pages/Home'));
const Products = lazy(() => import('../pages/Products'));
const Product = lazy(() => import('../pages/Product'));
const History = lazy(() => import('../pages/History'));
const ContactUs = lazy(() => import('../pages/ContactUs'));
const Consult = lazy(() => import('../pages/Consult'));
const PrivacyPolicy = lazy(() => import('../pages/PrivacyPolicy'));
const Http404 = lazy(() => import('../pages/Http404'));

export interface RouteConfig {
  key: string;
  path: string;
  component: LazyExoticComponent<FC>;
  modeModal: boolean;
  skeleton?: FC;
}

const getRouteConfig = (
  key: string,
  path: string,
  component: RouteConfig['component'],
  modeModal = false,
  skeleton?: FC,
): RouteConfig => ({
  key,
  path,
  component,
  modeModal,
  skeleton,
});

const publicRoutes = {
  products: getRouteConfig('products', '/products', Products, false, ProductsSkeleton),
  product: getRouteConfig('product', '/products/:id', Product, false, ProductDetailSkeleton),
  history: getRouteConfig('history', '/history', History, false, HistorySkeleton),
  contactUs: getRouteConfig('contact-us', '/contact-us', ContactUs, false, ContactSkeleton),
  consult: getRouteConfig('consult', '/consult', Consult, false, ConsultSkeleton),
  privacyPolicy: getRouteConfig(
    'privacy-policy',
    '/privacy-policy',
    PrivacyPolicy,
    false,
    ArticleSkeleton,
  ),
};

const homeRoute = getRouteConfig('home', '/', Home, false, HomeSkeleton);

export default {
  publicRoutes,
  homeRoute,
  notFoundComponent: Http404,
};
